/* Relógio
   ========================================================================== */

let lastTime = performance.now();
let deltaTime;

const frameInterval = function frameInterval() {
  const currentTime = performance.now();

  deltaTime = currentTime - lastTime;

  lastTime = currentTime;

  requestAnimationFrame(frameInterval);
}

requestAnimationFrame(frameInterval);
